export default "__VITE_ASSET__rSoXXvAd__"